/**
 * Cannot use a namespace here because Typescript namespaces don't support re-exporting for some reason
 */
import { isServerSide } from 'src/utils/validators/isServerSide';
import { areIntegrationTestsRunning } from 'src/utils/validators/areIntegrationTestsRunning';
import { ClientConfigProvider } from '../ClientConfigProvider';
import { CallbackURLSanitizer } from './CallbackURLSanitizer';

import { RouteConfigurationServiceDomain } from './domain';
export { RouteConfigurationServiceDomain as Domain };

export class ConfigProvider extends ClientConfigProvider {
    readonly #sanitizer: CallbackURLSanitizer = new CallbackURLSanitizer();

    public getSafeCallbackUrl(callbackURL: string | null, currentPathname: string): string {
        if (this.#sanitizer.isSafeCallbackUrl(callbackURL)) {
            return callbackURL;
        }
        return this.#sanitizer.getSafeCallbackUrl(currentPathname);
    }

    public get zillowDomain(): RouteConfigurationServiceDomain.ZillowDomain {
        if (this.runtimeConfig.isLowerEnvironment) {
            return RouteConfigurationServiceDomain.ZillowDomain.NON_PRODUCTION;
        }
        return RouteConfigurationServiceDomain.ZillowDomain.PRODUCTION;
    }

    public get zillowHomeLoansHomePage(): string {
        return `${this.zillowDomain}${RouteConfigurationServiceDomain.ExternalRoute.HOMELOANS_LANDING_PAGE}`;
    }

    public get newUserDestination(): string {
        if (!this.runtimeConfig.isLowerEnvironment || isServerSide() || !areIntegrationTestsRunning()) {
            return `${this.zillowDomain}${RouteConfigurationServiceDomain.ApplicationRoute.MISSING_DASHBOARD}`;
        }
        // return local so Cypress can handle prequal on MRs and staging.
        return RouteConfigurationServiceDomain.ApplicationRoute.MISSING_DASHBOARD;
    }
}
